import React from 'react';

export default {
  sm: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H16V16H0z" />
        <path
          className="icon-color"
          fillRule="nonzero"
          d="M13 5V4H2v8h11v-1h-3c-.552 0-1-.448-1-1V6c0-.552.448-1 1-1h3zm2 6v1c0 1.105-.895 2-2 2H2c-1.105 0-2-.895-2-2V4c0-1.105.895-2 2-2h11c1.105 0 2 .895 2 2v1c.552 0 1 .448 1 1v4c0 .552-.448 1-1 1zm-4-4v2h3V7h-3z"
        />
      </g>
    </svg>
  ),
  md: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H24V24H0z" />
        <path
          className="icon-color"
          fillRule="nonzero"
          d="M19 9V7H4v10h15v-2h-3c-.552 0-1-.448-1-1v-4c0-.552.448-1 1-1h3zm2 6v2c0 1.105-.895 2-2 2H4c-1.105 0-2-.895-2-2V7c0-1.105.895-2 2-2h15c1.105 0 2 .895 2 2v2c.552 0 1 .448 1 1v4c0 .552-.448 1-1 1zm-4-4v2h3v-2h-3z"
        />
      </g>
    </svg>
  ),
};
